
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmCurrentTime,
  VmTime 
} from '@vime/core';

import { define } from '../lib';
  

const CurrentTimeInputs: string[] = [
  'currentTime',
  'i18n',
  'alwaysShowHours',
];

const CurrentTimeMethods: string[] = [
  
];

const CurrentTimeOutputs: string[] = [
  
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface CurrentTime extends Components.VmCurrentTime {}

@ProxyCmp({
  inputs: CurrentTimeInputs,
  methods: CurrentTimeMethods,
})
@Component({
  selector: 'vm-current-time',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: CurrentTimeInputs,
  outputs: CurrentTimeOutputs,
})
export class CurrentTime {
  protected el: HTMLElement;

  

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-current-time', VmCurrentTime);
    define('vm-time', VmTime);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, [])
  }
}
  